import { Wording } from '@/types';

export const ASTROLOGY_WORDING_NO: Wording = {
  components_header_media_content: 'Audio zapisi',
  components_header_media_1: 'Meditacije',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Istražite zvijezde u sebi',
  hero_button_text: 'Počnite ovdje',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi alati koji su vam potrebni za kosmički uvid i samospoznaju',
  components_ressources_span_text: 'Proširite svoj unutrašnji univerzum uz odabranu mješavinu podcasta i članaka. Bez obzira da li tražite kosmički uvid, jasnoću ili duhovno usklađivanje, naši resursi vam pomažu da se povežete s astrologijom na praktične i smislene načine.',
  components_ressources_card_1_title: 'Dubinske analize',
  components_ressources_card_1_text: 'Zaronite u bogatu kolekciju detaljnih podcasta koji pokrivaju astrologiju, tarot, kosmičke arhetipove i duhovni rast – osmišljenih da prošire vašu svijest i prodube vašu praksu.',
  components_ressources_card_2_title: 'Zvjezdani uvidi',
  components_ressources_card_2_text: 'Astrološki savjeti i blog postovi za samosvijest i duhovni rast.',
  components_ressources_link: 'Istražite dalje',
  components_notes_and_google_title_1: 'Astrološko vodstvo',
  components_notes_and_google_title_2: 'Kosmička rutina',
  components_notes_and_google_title_3: 'Razmišljanja',
  components_review_google_text: 'Recenzije',
  media_content_section_title: 'ZVUKOVI',
  media_content_section_subheader_text: 'Naš podcast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više epizoda',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci i uvidi',
  text2_section_button_more: 'Učitaj više',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Pogledajte sve vodiče',
  components_footer_text: 'Probudite svoj unutrašnji kosmos: Vaš put, vaše zvezde.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registarski broj',
  components_footer_legal: 'Pravno',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj više',
  page_media_1_content_hero_text: 'Epizode podcasta',
  page_media_content_menu_foundations: 'Temelji',
  page_media_content_menu_spirituality: 'Duhovnost',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologija',
  page_media_content_menu_trends: 'Trendovi',
  page_media_2_content_hero_text: 'Mediji 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci i uvidi',
  enter_email_title: 'Molimo unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'E-pošta',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava uspješna!',
  components_card_link_media_content: 'Slušajte sada',
  components_card_link_text1_content: 'Pogledajte vodič',
  components_card_link_text2_content: 'Pogledajte članak',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditacija',
  page_media_content_menu_all: 'Svi',
};